import {useRef, use, useEffect} from 'react';

import {ContextMenu} from './ContextMenu';
import {ContextMenuContext} from './ContextMenuContext';
import {ContextMenuWrapper} from './styles';
import {ContextMenuWithContextProps} from './types';
import {closeMenu} from './utils/closeMenu';
import {openMenu} from './utils/openMenu';

export const ContextMenuWithContext = ({
  id,
  children,
  contextMenuProps,
  ...rest
}: ContextMenuWithContextProps) => {
  const {onClose, ...menuProps} = contextMenuProps;
  const wrapperRef = useRef<HTMLDivElement>(null);
  const context = use(ContextMenuContext);

  const handleContextMenu = (e: MouseEvent) => {
    if (context) {
      openMenu(e, context, id);
    }
  };

  useEffect(function subscribeToContextMenu() {
    const _wrapper = wrapperRef.current;
    _wrapper?.addEventListener('contextmenu', handleContextMenu);

    return () => {
      _wrapper?.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []); // eslint-disable-line react/exhaustive-deps -- Muted pre-existing violation

  return (
    <ContextMenuWrapper {...rest} ref={wrapperRef}>
      <ContextMenu
        open={!!context?.menuState && context.menuState?.id === id}
        onClose={() => {
          if (context) {
            closeMenu(context);
          }
          if (onClose) {
            onClose();
          }
        }}
        position={context?.menuState ?? undefined}
        {...menuProps}
      />
      {children}
    </ContextMenuWrapper>
  );
};
